{{#if currentItem.printFiles}}
    <ul class="fileUpload-list" data-item-id="{{currentItem.id}}">
        {{#each currentItem.printFiles}}
            <li class="fileUpload-list-item js-element--fileUploadItem" data-file-id="{{id}}">
                <div class="lbl lbl_bold lbl_lg">{{name}}</div>
                <button class="fileUpload-list-item-remove {{#if (contains ../undoPrintFileIds id)}}isUndo js-action--undoRemoveFile{{else}}js-action--removeUploadedFile{{/if}}"></button>
            </li>
        {{/each}}
    </ul>
{{/if}}
